import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Gift } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface ExitIntentPopupProps {
  isOpen: boolean;
  onClose: () => void;
}

export function ExitIntentPopup({ isOpen, onClose }: ExitIntentPopupProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGetFreeTrial = () => {
    navigate('/auth?promo=pro_trial&tab=signup');
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-2 mb-2">
            <Gift className="w-8 h-8 text-primary animate-bounce" />
            <DialogTitle className="text-2xl">{t("landing.exitIntent.title")}</DialogTitle>
          </div>
          <DialogDescription className="text-base">
            {t("landing.exitIntent.description")}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 mt-4">
          <Button onClick={handleGetFreeTrial} className="w-full" size="lg">
            {t("landing.exitIntent.cta")}
          </Button>
          <p className="text-xs text-center text-muted-foreground">
            {t("landing.exitIntent.disclaimer")}
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
